import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

class ConfirmationModal extends Component {
  static propTypes = {
    autoClose: PropTypes.bool,
    onExited: PropTypes.func,
    onConfirm: PropTypes.func,
    title: PropTypes.string,
    message: PropTypes.string,
    warning: PropTypes.string,
    info: PropTypes.string,
    matchText: PropTypes.string,
    matchTextAlt: PropTypes.string,
    checkText: PropTypes.string,
    checkAlign: PropTypes.oneOf(["left", "right", "center"]),
    btnType: PropTypes.oneOf([
      "success",
      "primary",
      "info",
      "danger",
      "warning"
    ]),
    disabled: PropTypes.bool
  };
  constructor(props) {
    super(props);
    const self = this;
    self.state = {
      standby: true,
      inputText: "",
      checked: false,
      show: true
    };
    self.onChangeInputText = self.onChangeInputText.bind(self);
    self.onToggleCheckbox = self.onToggleCheckbox.bind(self);
    self.onSubmit = self.onSubmit.bind(self);
    self.close = self.close.bind(self);
  }
  componentDidMount() {
    const self = this;
    self.setState({
      inputText: "",
      checked: false
    });
  }
  componentDidUpdate() {
    const self = this;
    let standby = true;
    if (self.props.matchText && self.state.inputText !== self.props.matchText) {
      standby = false;
    }
    if (self.props.checkText && !self.state.checked) {
      standby = false;
    }
    if (self.props.condition && !self.props.condition(self.props, self.state)) {
      standby = false;
    }
    if (self.state.standby !== standby) {
      self.setState({ standby: standby });
    }
  }
  onChangeInputText(event) {
    const self = this;
    self.setState({
      inputText: event.target.value
    });
  }
  onToggleCheckbox() {
    const self = this;
    self.setState({
      checked: !self.state.checked
    });
  }
  onSubmit(event) {
    event.preventDefault();
    const self = this;
    if (!self.state.standby) {
      return;
    }
    if (self.props.onConfirm) {
      self.props.onConfirm(() => {
        self.close();
      });
    }
    if (self.props.autoClose) {
      self.close();
    }
  }
  close() {
    this.setState({ show: false });
  }
  render() {
    const self = this;
    return (
      <Modal
        className="modal-container"
        show={self.state.show}
        onHide={self.close}
        onExited={self.props.onExited}
        animation={true}
      >
        <form onSubmit={self.onSubmit}>
          <Modal.Header closeButton>
            {self.props.title && (
              <div className="h5 mb-0">{self.props.title}</div>
            )}
          </Modal.Header>
          <Modal.Body>
            {self.props.warning && (
              <p class="alert alert-warning">{self.props.warning}</p>
            )}
            {self.props.info && (
              <p class="alert alert-info">{self.props.info}</p>
            )}
            {self.props.message && <p>{self.props.message}</p>}
            {self.props.children && self.props.children}
            {self.props.matchText && (
              <div className="mb-2">
                <p className="mb-1">
                  <code>{self.props.matchTextAlt || self.props.matchText}</code>
                  を入力
                </p>
                <input
                  type="text"
                  value={self.state.inputText}
                  className="form-control w-50"
                  onChange={self.onChangeInputText}
                />
              </div>
            )}
            {self.props.checkText && (
              <div className={`mb-2 text-${self.props.checkAlign || "left"}`}>
                <label className="custom-control custom-checkbox d-inline-block">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    onChange={self.onToggleCheckbox}
                    checked={self.state.checked}
                  />
                  <span className="custom-control-label d-inline-block">
                    {self.props.checkText}
                  </span>
                </label>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {self.props.cancelButton !== false && (
              <button
                className="btn btn-secondary"
                type="button"
                onClick={self.close}
              >
                {self.props.cancelButton || "キャンセル"}
              </button>
            )}
            <button
              className={`btn btn-${self.props.btnType || "primary"}`}
              type="submit"
              disabled={self.props.disabled || !self.state.standby}
            >
              {self.props.submitButton || "OK"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default ConfirmationModal;
